import React from "react";
import QuoteComponent from "../QuoteComponent";

const BRAND = { navy: "#062b6c", green: "#00ad0f" };

const GetQuote = () => {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      {/* HERO */}
      <section className="bg-gradient-to-br from-[#062b6c] via-[#020617] to-[#00ad0f]/70 text-slate-50">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 pt-24 pb-12 md:flex-row md:items-end md:pt-28 md:pb-14">
          <div className="flex-1">
            <p className="text-[11px] uppercase tracking-[0.28em] text-emerald-200/90">
              Request for Quote • RFQ
            </p>
            <h1 className="mt-2 text-3xl font-semibold md:text-4xl lg:text-[2.6rem]">
              Send us a request for quote
            </h1>
            <p className="mt-3 max-w-xl text-sm text-slate-200 md:text-[0.96rem]">
              Share your project details, scope, and requirements. Our team
              will review your request and respond with a tailored proposal,
              aligned with your technical and operational needs.
            </p>
          </div>

          <div className="mt-2 flex flex-col items-start gap-2 md:items-end">
            <span className="inline-flex items-center rounded-full bg-black/20 px-4 py-1 text-[10px] font-medium uppercase tracking-[0.2em] text-emerald-100">
              Engineering • Inspection • Lifting • Training
            </span>
            <span className="inline-flex items-center gap-1 rounded-full border border-emerald-300/80 bg-black/10 px-4 py-1 text-[10px] uppercase tracking-[0.2em] text-emerald-100">
              <span
                className="h-1.5 w-1.5 rounded-full"
                style={{ background: BRAND.green }}
              />
              Response within 24–72 hrs
            </span>
          </div>
        </div>
      </section>

      {/* RFQ BLOCK */}
      <section className="pb-16 pt-6">
        <div className="mx-auto max-w-6xl px-6">
          <QuoteComponent />
        </div>
      </section>
    </main>
  );
};

export default GetQuote;
